import React from "react";

export default function () {
  return (
    <div className="loader">
      <div id="loading" />
    </div>
  );
}
